const iFrames = document.querySelectorAll('.iframe-module__iframe iframe');

iFrames.forEach((el) => {
  iframeResize(
    {
      license: '1jy4dww5qzv-s54r73oxcn-v59f4kfgfz',
      waitForLoad: true,
      checkOrigin: false,
      heightCalculationMethod: 'bodyOffset',
    },
    el,
  );

  const iframe = el.contentWindow;

  window.addEventListener('message', (event) => {
    if (event.source !== iframe) {
      return; // Skip message in this event listener
    }

    if (event.data.event) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: event.data.event,
        label: event.data.label,
        form_id: event.data.form_id,
      });
    }
  });
});
